import { render } from "./AppCourseContextBar.vue?vue&type=template&id=43c57b59&scoped=true"
import script from "./AppCourseContextBar.vue?vue&type=script&lang=js"
export * from "./AppCourseContextBar.vue?vue&type=script&lang=js"

import "./AppCourseContextBar.vue?vue&type=style&index=0&id=43c57b59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c57b59"]])

export default __exports__